import * as z from "zod";
import { aeoDashboardFilterInput } from "./types";

const promptEntry_ = z.object({
  promptId: z.string(),
  text: z.string(),
  mentions: z.number().int(),
  sov: z.number(),
  visibility: z.number(),
  rank: z.number().int(),
});

export const getAeoDashboardTopicPrompts = {
  name: "getAeoDashboardTopicPrompts" as const,
  input: aeoDashboardFilterInput.and(z.object({ topicId: z.string() })),
  output: z.object({ prompts: z.array(promptEntry_) }),
};
